/**
 * `B` — horizontal band (§9.3). Drag down the picture: the band spans the
 * full width between the two rows. This is the fastest way to say
 * "everything below here is ground", and it is what Simple fix mode drives.
 */
import { idle, none, withState, type ToolHandler, type ToolResult } from './types'

/** A band thinner than this is a mis-click, not a shape. */
export const MIN_BAND_HEIGHT_PCT = 0.5

export const bandTool: ToolHandler = {
  id: 'band',
  shortcut: 'b',
  icon: 'Rows3',
  label: 'Band',
  hint: 'Drag down the picture to mark a stripe — sky, ground, water.',
  cursor: 'ns-resize',

  reduce(machine, ev, cfg): ToolResult | null {
    const st = machine.state

    if (ev.t === 'pointerdown' && ev.button === 0) {
      return withState('band', { t: 'band.dragging', y0: ev.at[1], y1: ev.at[1], kind: cfg.activeKind.region ?? '' })
    }

    if (ev.t === 'pointermove') {
      if (st.t !== 'band.dragging') return none(machine)
      return withState('band', { ...st, y1: ev.at[1] })
    }

    if (ev.t === 'pointerup') {
      if (st.t !== 'band.dragging') return none(machine)
      // The release row wins: a drag with no intervening move still works.
      const y0 = Math.min(st.y0, ev.at[1])
      const y1 = Math.max(st.y0, ev.at[1])
      if (y1 - y0 < MIN_BAND_HEIGHT_PCT) return idle('band')
      return idle('band', [{ k: 'beginGesture' }, { k: 'createBand', y0, y1, kind: st.kind || undefined }, { k: 'endGesture' }])
    }

    if (ev.t === 'cancel' || ev.t === 'pointercancel') return idle('band')

    return null
  },
}
